import {schema} from 'normalizr';

export const tournamentSchema = new schema.Entity('tournaments');
export const tournamentListSchema = [tournamentSchema];



// WEBPACK FOOTER //
// ./src/schemas/tournament.js